import { language } from "@chef/constants";

export const intl = {
  no: {
    INVITAION_SENT: "Invitasjonen er sendt!",
    YOU_KNOW_THAT_YOU_GET_A_DISCOUNT_PER_FRIEND:
      "Visste du at jo flere venner du verver, jo flere rabatter får du?",
    COLLECT_MORE_DISCOUNTS: "Samle flere rabatter",
    READ_MORE_ABOUT_THIS_MONTHS_COMPETITION: "Les mer om kampanjen!",
    INVITE_MORE_FRIENDS: "Verv flere venner",
  },
  se: {
    INVITAION_SENT: "Inbjudan skickad!",
    YOU_KNOW_THAT_YOU_GET_A_DISCOUNT_PER_FRIEND:
      "Du vet väl att du får en rabatt per vän, så fortsätt att tipsa och samla flera rabatter!",
    COLLECT_MORE_DISCOUNTS: "Samla flera rabatter",
    READ_MORE_ABOUT_THIS_MONTHS_COMPETITION: "Läs mer om kampanjen!",
    INVITE_MORE_FRIENDS: "Bjud in flera vänner",
  },
  dk: {
    INVITAION_SENT: "Sådan! Anbefalingen er sendt",
    YOU_KNOW_THAT_YOU_GET_A_DISCOUNT_PER_FRIEND:
      "Jo flere venner du anbefaler os til, jo flere rabatter kan du optjene.",
    COLLECT_MORE_DISCOUNTS: "Send ny anbefaling",
    READ_MORE_ABOUT_THIS_MONTHS_COMPETITION: "Læs mere om kampagnen!",
    INVITE_MORE_FRIENDS: "Anbefal til flere vener",
  },
}[language];
